import CoefficientsIcon from "@/components/icons/CoefficientsIcon";
import CommsIcon from "@/components/icons/CommsIcon";
import CompaniesIcon from "@/components/icons/CompaniesIcon";
import DashboardIcon from "@/components/icons/DashBoardIcon";
import MeasureIcon from "@/components/icons/MeasureIcon";
import SettingsIcon from "@/components/icons/SettingsIcon";
import UsersIcon from "@/components/icons/UsersIcon";
import type { LucideIcon } from "lucide-react";
import type { SVGProps } from "react";

export interface MenuItem {
  name: string;
  href: string;
  icon: LucideIcon | SVGProps<SVGSVGElement> | null;
  roles?: string[];
  canHide?: boolean;
}

export const baseNavigation: MenuItem[] = [];

export const adminNavigation: MenuItem[] = [
  {
    name: "menu.dashboard",
    href: "/dashboard",
    icon: DashboardIcon as any,
    roles: ["admin", "client"],
  },
  {
    name: "menu.measure",
    href: "/measure",
    icon: MeasureIcon as any,
    roles: ["admin", "client"],
    canHide: true,
  },
  {
    name: "menu.communication",
    href: "/communication",
    icon: CommsIcon as any,
    roles: ["admin", "client"],
  },

  // {
  //   name: "menu.configuración",
  //   href: "",
  //   icon: null,
  // },
  {
    name: "menu.users",
    href: "/users",
    icon: UsersIcon,
    roles: ["admin", "client"],
  },
  {
    name: "menu.companies",
    href: "/companies",
    icon: CompaniesIcon,
    roles: ["admin", "client"],
  },
  {
    name: "menu.coefficients",
    href: "/coefficients",
    icon: CoefficientsIcon as any,
    roles: ["admin"],
  },
  {
    name: "menu.settings",
    href: "/settings",
    icon: SettingsIcon,
    roles: ["admin"],
  },
];

export const configNavigation: MenuItem[] = [];
